import { useContext } from "react";
import "../common/elements/Header.scss";
import InsightsFooter from "./common/InsightsFooter";
import InsightsHeader from "./common/InsightsHeader";
import NavigatorSideNav from "./NavigatorSideNav";
import { InsightsUser } from "../common/interfaces/Interface";

import { sendRequestWithPayload } from "../../common/http";
import { ToolboxChat } from "@watermarkinsights/ai-toolbox";
import { AiChatWidget } from "./ai-chat/AiChatWidget";
import { AppContext, AppContextInterface } from "@/contexts/AppContext";

const { TOOLBOX_FEATURE_ID, TOOLBOX_PRODUCT } = runConfig;

export const InsightsHeaderSidebar = ({
  user,
  children,
  hideNavigatorSideNav,
  showAiChat = false,
}: {
  user: InsightsUser;
  children: JSX.Element;
  hideNavigatorSideNav?: boolean;
  showAiChat?: boolean;
}) => {
  const { setAiChatToggleVisible } = useContext<AppContextInterface>(AppContext);

  const mainContent = (
    <main className="contentwrapper background">
      <div id="maincontent">
        <>{children}</>
      </div>
      <InsightsFooter />
    </main>
  );

  return (
    <div
      className={
        hideNavigatorSideNav
          ? "pagewrapper show-toggle-nav-container"
          : "pagewrapper newHome"
      }
    >
      <InsightsHeader hideNavigatorSideNav={hideNavigatorSideNav} />
      <div className="nav-main">
        {user && user.uuid !== "" && user.roles.includes("administrator") && (
          <NavigatorSideNav
            hideNavigatorSideNav={hideNavigatorSideNav}
            collapseSideNav={true}
          />
        )}
        <ToolboxChat
          featureId={TOOLBOX_FEATURE_ID}
          product={TOOLBOX_PRODUCT}
          sessionUrl={() =>
            new Promise((resolve, reject) => {
              sendRequestWithPayload(
                { uri: "/home/toolbox-session", camelize: true },
                (result: any) => {
                  if (result?.sessionId) {
                    setAiChatToggleVisible(true);
                    resolve(result);
                  } else {
                    setAiChatToggleVisible(false);
                    reject(result);
                  }
                },
                (error: any) => {
                  setAiChatToggleVisible(false);
                  reject(error);
                },
              );
            })
          }
          fallback={mainContent}
        >
          {mainContent}
          {showAiChat && <AiChatWidget />}
        </ToolboxChat>
      </div>
    </div>
  );
};
